import React from 'react';
import { compose, hoistStatics, defaultProps } from 'recompose';
import { Badge } from 'reactstrap';
import { translate } from 'react-i18next';
import Items from './Items';
import ModelService from '../../services/extModule.service';
import columnTypes from '../../components/cms/grid/columnTypes';

const getColumns = t => [
  {
    name: 'id',
    title: t('Id'),
  },
  {
    name: 'name',
    title: t('Name'),
  },
  {
    name: 'title',
    title: t('Title'),
  },
  {
    name: 'git',
    title: t('Git'),
  },
  {
    type: columnTypes.BUTTONS,
  },
];

const enhance = compose(
  translate('core'),
  defaultProps({
    getColumns,
    service: ModelService,
  }),
);

export default hoistStatics(enhance)(Items);



// WEBPACK FOOTER //
// ./src/views/extModules/index.js